@if (control) {
  @if (disabled || control.disabled) {
    <div class="break-words whitespace-normal leading-relaxed" [id]="inputId"
         [attr.aria-labelledby]="labelledBy" [innerHTML]="control.value"></div>
  } @else {
    <p-editor
      (onInit)="onEditorInit($event)"
      [formControl]="control"
      [id]="inputId"
      [style]="{ height: '320px' }"
    >
      <ng-template #header>
                <span class="ql-formats" pTooltip="Família da fonte" tooltipPosition="top">
                    <select aria-label="Font" class="ql-font"></select>
                </span>
        <span class="ql-formats" pTooltip="Tamanho da fonte" tooltipPosition="top">
                    <select aria-label="Size" class="ql-size">
                      <option value="small">Pequena</option>
                      <option selected value="">Normal</option>
                      <option value="large">Grande</option>
                      <option value="huge">Enorme</option>
                    </select>
                </span>
        <span class="ql-formats">
                    <button aria-label="Bold" class="ql-bold" pTooltip="Negrito" tooltipPosition="top"
                    ></button>
                    <button aria-label="Italic" class="ql-italic" pTooltip="Itálico" tooltipPosition="top"
                    ></button>
                    <button aria-label="Underline" class="ql-underline" pTooltip="Sublinhado" tooltipPosition="top"
                    ></button>
                       <button aria-label="Strike" class="ql-strike" pTooltip="Tachado" tooltipPosition="top"
                       ></button>
                </span>
        <span class="ql-formats" pTooltip="Cor do texto" tooltipPosition="top">
                    <select aria-label="Color" class="ql-color"></select>
                </span>
        <span class="ql-formats" pTooltip="Cor de fundo" tooltipPosition="top">
                    <select aria-label="Background" class="ql-background"></select>
                </span>
        <span class="ql-formats">
                  <button aria-label="Header1" class="ql-header" pTooltip="Título 1" tooltipPosition="top"
                          value="1"></button>
                  <button aria-label="Header2" class="ql-header" pTooltip="Título 2" tooltipPosition="top"
                          value="2"></button>
                  <button aria-label="Blockquote" class="ql-blockquote" pTooltip="Citação"
                          tooltipPosition="top"></button>
                </span>
        <span class="ql-formats">
                  <button class="ql-list" type="button" pTooltip="Lista" tooltipPosition="top"
                          value="bullet"></button>
                </span>
        <span class="ql-formats" pTooltip="Alinhar" tooltipPosition="top">
                    <select aria-label="Align" class="ql-align"></select>
                </span>
      </ng-template>
    </p-editor>
  }
}
